export const modalType = {
    read: 'read',
    create: 'create',
    modify: 'modify',
}